export default __webpack_public_path__ + "static/media/logo.6da7c3f9.svg";